import axios from 'axios';
import { BASE_URL } from '../global/Constants/Constants';

const api = axios.create({
    baseURL: BASE_URL,
});

const waitForSession = () => {
    return new Promise((resolve) => {
        const getSession = () => localStorage.getItem('Session_Id');
        
        if (getSession()) {
            return resolve(getSession());
        }

        const interval = setInterval(() => {
            const sessionId = getSession();
            if (sessionId) {
                clearInterval(interval);
                resolve(sessionId);
            }
        }, 300);

        setTimeout(() => {
            clearInterval(interval);
            resolve(null);
        }, 15000);
    });
};

api.interceptors.request.use(async (config) => {
    if (config.url.includes('/login') || config.url.includes('/auth') || config.url.includes('/Registration')) {
        return config;
    }

    const sessionId = await waitForSession();
    if (sessionId) {
        config.headers['Session_Id'] = sessionId;
    }
    
    return config;
});

async function handleResponse(response) {
    if (response.data.IsSuccess) {
        return response.data.Data;
    } else {
        const error = response.data.Message;
        throw new Error(error);
    }
}

function handleError(error) {
    throw error;
}

export { api, handleResponse, handleError };